export default "__VITE_ASSET__DSZ5eG2Z__"